<template>
  <a target="_blank" href="https://www.facebook.com/bbva.argentina/">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <defs>
        <path
          id="a-face"
          d="M16.3 8.3h-1.394c-1.031 0-1.206.519-1.206 1.234V11.1h2.44l-.328 2.5H13.7V20h-2.5v-6.4H9v-2.5h2.2V9.29C11.2 7.16 12.496 6 14.391 6c.906 0 1.609.067 1.909.101V8.3zM13 1C6.373 1 1 6.373 1 13s5.373 12 12 12 12-5.373 12-12S19.627 1 13 1z"
        />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h26v26H0z" />
        <mask id="b-face" fill="#5BBEFF">
          <use xlink:href="#a-face" />
        </mask>
        <use class="hover--icon" fill="#5BBEFF" xlink:href="#a-face" />
        <g fill="#5BBEFF" mask="url(#b-face)">
          <path class="hover--icon" d="M0 0h26v26H0z" />
        </g>
      </g>
    </svg>
  </a>
</template>
<script>
export default {
  name: "FacebookImage"
};
</script>

<style scoped>
a:hover .hover--icon {
  fill: #fff;
}
</style>
